import ApiPage from '../api-page';


class EditApplicationPage extends ApiPage {

}


export default EditApplicationPage;
